import { render, staticRenderFns } from "./ColumnsMod.vue?vue&type=template&id=4ec455ce"
import script from "./ColumnsMod.vue?vue&type=script&lang=js"
export * from "./ColumnsMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports